/*
 * The words for each theme, in ONE place (#485, #487).
 *
 * Lifted out of ThemeSettingsTab when the upgrade nudge needed the same
 * titles and descriptions. Two copies of this map would be two places to
 * fix a wording change, and the nudge and the picker describing the same
 * preset differently is exactly the drift the mirrored-file convention in
 * this codebase exists to stop.
 *
 * api/tests/unit/test_theme_names_agree_everywhere.py reads this file to
 * hold these keys to what V128 seeds, and to the mobile picker's copy.
 */
/*
 * COPY ONLY. Which of these an account may actually pick, and the tier
 * each one needs, comes from the server (`themes` on the theme payload)
 * -- see api/services/theme.py get_theme_options. The rule is "the most
 * expensive feature in that preset's own set", which needs the feature
 * catalogue to evaluate, and #243 settled that the server names the tier
 * where something is locked so the two apps cannot disagree.
 *
 * A name here that the server does not know is simply not rendered, so
 * this list going stale shows too few cards rather than a card whose
 * Select button 400s.
 */
export const THEME_COPY = {
  Basic: {
    title: "Basic",
    description: "Simple, clean essentials: hives, business core, one-click actions.",
  },
  "Hive Keeping": {
    title: "Hive Keeping",
    description:
      "For looking after the bees: treatments, feeding, queens, splits, health scores and what is in bloom. No business screens.",
  },
  "Honey Selling": {
    title: "Honey Selling",
    description:
      "Hive Keeping plus the honey side: harvests, the pool, bottle sizes, who got jars, equipment and what the season cost.",
  },
  "Honey Business": {
    title: "Honey Business",
    description:
      "Everything in Honey Selling plus the books: vendor ledgers, balances and aging, standing orders and forecasting.",
  },
  "Inspection Ready": {
    title: "Inspection Ready",
    description:
      "Built around the records an inspector asks for: treatments, health, queens, harvests and regulatory reporting.",
  },
  Advanced: {
    title: "Advanced",
    description: "Everything unlocked: health scoring, treatments, queens, team, reports, and more.",
  },
  Custom: {
    title: "Custom",
    description: "Pick exactly which advanced features you want, individually.",
  },
};
